import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { COLORS } from '../../constants'

type NavbarContainerProps = {
  $backgroundColor: string
}

export const NavbarContainer = styled.nav<NavbarContainerProps>`
  background-color: ${(props) => props.$backgroundColor};
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const AppName = styled.h1`
  font-size: 2rem;
  color: ${COLORS.primary};
  margin-left: 3rem;
  font-weight: 700;
`

export const NavLogo = styled(Link)`
  display: flex;
  align-items: center;
`

export const LogoImage = styled.img`
  height: 40px;
  width: auto;
`

export const NavItems = styled.ul`
  list-style: none;
  display: flex;
  gap: 1.5rem;
`

export const NavItem = styled.li`
  color: ${COLORS.primary};
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-right: 5rem;
  text-decoration: none;

  &:hover {
    color: ${COLORS.secondary};
  }
`

export const Title = styled.div`
  color: inherit;
  transition: color 0.3s ease;
  margin-top: 0.1rem;
`

export const Div = styled.div`
  display: flex;
  align-items: center;
`
